<div>
  <div class="modal-header">
    <h4 class="modal-title" translate>
      page.declarations.drev.modal.vci.title
    </h4>
  </div>

  <div class="modal-body">
    <div class="flex flex-row">
      <!-- tanks sidebar -->
      <div class="tanks-sidebar">
        <h3 [translateParams]="{annee:campagne}" translate>page.declarations.drev.modal.vci.declaration-recolte</h3>
        <div class="flex flex-row tanks">
          <div>
            <app-tank [data]="{value:100, color:'#875ebf'}"></app-tank>
            <div class="text-center">
              {{drev.volumeNetRevendiqueEncours | number:'1.0-2'}} hL <span><br/>{{'page.declarations.drev.modal.vci.stock-vci-vol-rev' | translate}}</span>
            </div>
          </div>

          <strong>+</strong>

          <div class="text-center">
            <app-tank [data]="{value:getTankValue('vciNouveau'), color:'#AD92D3'}"></app-tank>
            <div>
              {{drev.drevSaisie.vciNouveau | number:'1.0-2'}} hL <br/><span>{{'page.declarations.drev.modal.vci.stock-vci-L19' | translate}}</span>
            </div>
          </div>

          <div class="separateur"></div>

          <div>
            <app-tank [data]="[{value:getTankValue('stockVci'), color:'#f68235'}]"></app-tank>
            <div class="text-center">
              {{getFieldValue('stock') | number:'1.0-2' }} hL <br/><span>{{'page.declarations.drev.modal.vci.stock-vci-n-1' | translate:{'annee':campagne-1} }}</span>
            </div>
          </div>
        </div>

        <hr/>

        <h3 [translateParams]="{annee:campagne}" translate>page.declarations.drev.modal.vci.declaration-revendication</h3>
        <div class="flex flex-row tanks">
          <div>
            <app-tank [data]="getDrevTankData()"></app-tank>
            <div class="text-center">
              {{drev.vinsEnCours + getFieldValue('complement') | number:'1.0-2' }} hL <br/><span>{{'page.declarations.drev.modal.vci.stock-vci-vol-revendique' | translate}}</span>
            </div>
          </div>

          <div>
            <app-tank [data]="getVciTankData()"></app-tank>
            <div class="text-center">
              {{ getFieldValue('remplacement') + drev.drevSaisie.vciNouveau | number:'1.0-2' }} hL <br/><span>Stock VCI {{campagne}}</span>
            </div>
          </div>

          <div></div>
        </div>
      </div>
      <!-- end tanks sidebar -->
      <div class="separateur" style="height:auto;margin: 0 0.5em;"></div>
      <!-- form -->
      <form id="form" [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submit()" novalidate  *ngIf="loaded">
        <h3 [translateParams]="{annee:campagne-1}" translate>page.declarations.drev.modal.vci.utilisation-stock-vci</h3>

        <div class="mb-3">
            <div class="input-group">
              <label for="stock" translate class="me-2">
                page.declarations.drev.modal.vci.stock
              </label>
              <input
                type="number"
                lang="en"
                [readonly]="!creation"
                formControlName="stock"
                class="form-control col-sm-2"
                [ngClass]="{
                  'is-invalid': form.submitted && getField('stock').invalid
                }"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-icon"
                  (click)="stockVci()"
                >
                  <fa-icon [icon]="'search'"></fa-icon>
                </button>
              </div>
            </div>
            <div
              *ngIf="form.submitted && getField('stock').invalid && getField('stock').errors?.somme_incorrecte"
              class="msg_erreur"
              translate
            >
              page.declarations.drev.modal.vci.somme_incorrecte
            </div>
          </div>

        <div class="mb-3">
          <label class="form-label" for="remplacement" translate>page.declarations.drev.modal.vci.remplacement</label>
          <input type="number"
                [readonly]="!creation" lang="en" formControlName="remplacement" class="form-control" [ngClass]="{'is-invalid': form.submitted && getField('remplacement').invalid}" />
        </div>

        <div class="mb-3">
          <label class="form-label" for="substitution" translate>page.declarations.drev.modal.vci.substitution</label>
          <input type="number" [readonly]="!creation" lang="en" formControlName="substitution" class="form-control" [ngClass]="{'is-invalid': form.submitted && getField('substitution').invalid}" />
        </div>

        <div class="mb-3">
          <label class="form-label" for="complement" translate>page.declarations.drev.modal.vci.complement</label>
          <input type="number" [readonly]="!creation" lang="en" formControlName="complement" class="form-control" [ngClass]="{'is-invalid': form.submitted && getField('complement').invalid}" />
        </div>

        <div class="mb-3">
          <label class="form-label" for="detruit" translate>page.declarations.drev.modal.vci.detruit</label>
          <input type="number" [readonly]="true" lang="en" formControlName="detruit" class="form-control" readonly="true" [ngClass]="{'is-invalid': form.submitted && getField('detruit').invalid}" />
        </div>


          <!-- Formulaire distillation -->
          <div formArrayName="distillations">
            <div *ngFor="let distillation of getDistillations(); let i = index" [formGroupName]="i">
              <div class="row" *ngIf="i == 0">
                <div class="mb-3 col-sm-3 text-start">{{ 'page.declarations.drev.modal.vci.type' | translate }}</div>
                <div class="mb-3 col-sm-3 text-start">{{ 'page.declarations.drev.modal.vci.date' | translate }} </div>
                <div class="mb-3 col-sm-2 text-start">{{ 'page.declarations.drev.modal.vci.volume' | translate }} </div>
                <div class="mb-3 col-sm-3 text-start">{{ 'page.declarations.drev.modal.vci.fichier' | translate }} </div>
                <div class="mb-3 col-sm-1"></div>
              </div>

              <div class="row">
                <div class="mb-3 col-sm-3">
                  <select formControlName="type" class="form-control" required >
                    <option [ngValue]="null" hidden selected>{{ 'page.declarations.drev.modal.vci.type-placeholder' | translate }}</option>
                    <option *ngFor="let ref of refMvtDistillations" [ngValue]="ref">{{ ref.libelle }}</option>*/

                  </select>
                </div>

                <div class="mb-3 col-sm-3">
                  <div class="input-group">
                  <input id="dateDistillation"
                        ngbDatepicker
                        #dateDistillation="ngbDatepicker"
                        formControlName="dateDistillation"
                        class="form-control" />

                  <div class="input-group-append">
                    <button type="button"
                            (click)="dateDistillation.toggle()"
                            class="btn btn-secondary">
                      <fa-icon icon="calendar-alt"></fa-icon>
                    </button>
                  </div>
                </div>
                              </div>

                <div class="mb-3 col-sm-2">
                  <input type="number" lang="en" formControlName="volume" class="form-control" (change)="sommeVol()" required [ngClass]="{'is-invalid': form.submitted && formGroup.get('distillations.' + i + '.volume').invalid, 'select-placeholder' : (formGroup.get('distillations.' + i + '.volume').value === null && !formGroup.get('distillations.' + i + '.volume').dirty)}" />
                </div>

                <div class="mb-3 col-sm-3">
                    <label class="custom-file-upload">
                      Parcourir
                      <input
                      type="file"
                      id="fichier"
                      formControlName="fichier"
                      (change)="onFileChange($event, distillation)"
                      />
                    </label>
                    <span *ngIf="uploadEnCours" class="spinner-border" role="status"></span>
                </div>


                <div class="mb-3 col-sm-1">
                  <div *ngIf="distillation.get('fichierUuid')?.value">
                   <fa-icon
                      icon="download"
                      (click)="onDownloadFile(distillation.get('fichierUuid')?.value)"
                      title="Télécharger"
                    ></fa-icon>
                  </div>
                  <fa-icon class="pointer deleteIcon" icon="trash" title="{{ 'page.declarations.drev.modal.vci.supprimerDistillation' | translate }}" (click)="remove(i)"></fa-icon>
                </div>
              </div>
            </div>
          </div>
          <button class="lienAffichage" type="button" (click)="add()" *ngIf="creation" >
            <fa-icon icon="plus"></fa-icon> {{ 'page.declarations.drev.modal.vci.creerDistillation' | translate }}
          </button>

      </form>


      <!-- end form -->
    </div>

    <div class="actions-bar">
      <button class="btn btn-light" (click)="dismiss()" translate>label.annuler</button>
      <button type="submit" class="btn btn-primary" form="form" translate>label.valider</button>
    </div>
  </div>

  <ng-template #stockVCIModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Stock VCI {{ campagne-1 }}  {{ drev.produit.libelle }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
      <table aria-label="Tableau des VCI" class="table table-striped" *ngIf="drevsN1?.length > 0; else aucunStock">
      <thead>
        <tr>
          <th class="liste-col-header" >Produit</th>
          <th class="liste-col-header" >Mention valorisante</th>
          <th class="liste-col-header" >VCI en stock (hl)</th>
        </tr>
      </thead>
      <tbody>
           <tr *ngFor="let stock of drevsN1">
              <td>{{ stock.produit.libelle}}</td>
              <td>{{ stock.mention}}</td>
              <td class="text-end">{{ stock.vciEnCours}}</td>
           </tr>
      </tbody>
      <tfoot>
        <tr>
    <td colspan="2" class="font-weight-bold">Total</td>
    <td class="text-end font-weight-bold">
      {{ getTotalVCI() }}
    </td>
  </tr>
      </tfoot>
      </table>
    <ng-template #aucunStock>
      <div class="alert alert-warning alert-block" translate>
        <fa-icon icon="exclamation"></fa-icon> page.declarations.drev.modal.vci.aucunStock
      </div>
    </ng-template>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Fermer</button>
  </div>
</ng-template>


</div>

